module.exports = __webpack_public_path__ + "static/img/icon_j.3e5f276d.png";